import { render, staticRenderFns } from "./AddSegmentation.vue?vue&type=template&id=107e1f14&"
import script from "./AddSegmentation.vue?vue&type=script&lang=js&"
export * from "./AddSegmentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports